import styled, { css } from 'styled-components';

export type TooltipPlacement = 'top' | 'bottom' | 'left' | 'right';

interface TooltipTextProps {
  minWidth: number;
  $placement: TooltipPlacement;
}

const arrowBase = css`
  content: '';
  position: absolute;
  width: 0;
  height: 0;
  border: 0.5rem solid transparent;
`;

const placementStyles = {
  top: css`
    bottom: calc(100% + 1rem);
    left: 50%;
    transform: translate(-50%, 0);
    &:after {
      ${arrowBase};
      top: 100%;
      left: 50%;
      transform: translateX(-50%);
      border-top-color: rgba(66, 101, 227, 1);
    }
  `,
  bottom: css`
    top: calc(100% + 1rem);
    left: 50%;
    transform: translate(-50%, 0);
    &:after {
      ${arrowBase};
      bottom: 100%;
      left: 50%;
      transform: translateX(-50%);
      border-bottom-color: rgba(66, 101, 227, 1);
    }
  `,
  left: css`
    right: calc(100% + 1rem);
    top: 50%;
    transform: translate(0, -50%);
    &:after {
      ${arrowBase};
      left: 100%;
      top: 50%;
      transform: translateY(-50%);
      border-left-color: rgba(66, 101, 227, 1);
    }
  `,
  right: css`
    left: calc(100% + 1rem);
    top: 50%;
    transform: translate(0, -50%);
    &:after {
      ${arrowBase};
      right: 100%;
      top: 50%;
      transform: translateY(-50%);
      border-right-color: rgba(66, 101, 227, 1);
    }
  `,
};

export const TooltipText = styled.span<TooltipTextProps>`
  display: none;
  opacity: 0;
  visibility: hidden;
  position: absolute;
  background: rgba(66, 101, 227, 1);
  font-size: 1.8rem;
  color: #fff;
  padding: 0.2em 1em;
  border-radius: 0.2em;
  white-space: nowrap;
  ${({ minWidth }) => (minWidth ? `min-width: ${minWidth}px;` : '')}
  ${({ $placement }) => placementStyles[$placement]}
`;

export const Root = styled.div`
  position: relative;
  &.hover ${TooltipText} {
    display: block;
    transition: 0.3s ease-in-out 1s;
    opacity: 1;
    visibility: visible;
  }
`;
